import * as React from 'react';
import { Ajax } from '@shared/Ajax';
import { DateSpan } from '@shared/ui-react/UtilComponents';


export class GanttPopup extends React.Component<{
    modelId: number
}> {
    state = {
        tasks: []
    };

    componentDidMount() {
        Ajax({
            url: 'schedule/model/' + this.props.modelId +'.json'
        }).done(resp => {
            const sortedByPosition = resp.scheduleItems.sort((a,b) => a.position - b.position);

            this.setState({
                tasks: sortedByPosition
            });
        });
    }

    render() {
        if (this.state.tasks.length === 0) return null;
        return (
            <div className='card' style={{ padding: 5 }}>
                <table className='simple-table' style={{ fontSize: 12 }}>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>{__('general.name')}</th>
                            <th>{__('schedule.edit_progress')}</th>
                            <th>{__('general.start_time')}</th>
                            <th>{__('general.end_time')}</th>
                        </tr>
                    </thead>

                    <tbody>
                        { this.state.tasks.map(task => (
                            <tr key={task.id}>
                                <td>{task.position}</td>
                                <td className='no-break-text'>{task.name}</td>
                                <td>
                                    <div style={{ width: 150, border: '1px solid ' + (task.color || '#ccc') }}>
                                        <div style={{ width: task.progress + '%', backgroundColor: task.color || '#ccc', paddingLeft: 5, color: task.progress < 10 ? 'black' : 'white' }}>
                                            {Math.round(task.progress)}%
                                        </div>
                                    </div>
                                </td>
                                <td><DateSpan timestamp={task.startDate}/></td>
                                <td><DateSpan timestamp={task.endDate}/></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }
}
